const UseGetFormData = (FormRef) => {

    const Data = new FormData(FormRef.current);
    const Checkboxes = Array.from(FormRef.current.querySelectorAll("input[type='checkbox']"));

    if (Checkboxes.length > 0) {
        Checkboxes.forEach((item) => {
            Data.set(item.name, item.checked ? 'on' : 'off')
        })
    }

    return Data
}

export default UseGetFormData;
